var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-group',{attrs:{"label":_vm.$t('Language')}},[_c('b-form-select',{attrs:{"options":_vm.langOptions},model:{value:(_vm.lang),callback:function ($$v) {_vm.lang=$$v},expression:"lang"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }